module.exports = __webpack_public_path__ + "static/media/Homepage_FPG_video_header_NIEUW_optie1.6121dabb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Homepage/Homepage_FPG_video_header_NIEUW_optie1.jpg
// module id = 687
// module chunks = 0